var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPictureInPicture = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.667 25.333V6.667h18.666V17H28V6.667C28 5.187 26.8 4 25.333 4H6.667A2.666 2.666 0 0 0 4 6.667v18.666C4 26.8 5.2 28 6.667 28H15v-2.667H6.667z",
  fill: "#A1A3A5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.933 9.974H17v7.32H9.765v-2.091h3.71L7.934 9.474 9.39 8l5.543 5.728V9.974z",
  fill: "#A1A3A5"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 17,
  y: 19,
  width: 11,
  height: 9,
  rx: 2,
  fill: "#A1A3A5"
})));
export default SvgPictureInPicture;